import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Alert,
} from 'react-bootstrap';
import types from '../../types';
import selectors from '../../redux/selectors';
import actions, { pick, bindActionCreators } from '../../redux/actions';

const Toast = ({ toast, closeToast }) => (
  <Alert
    bsStyle={toast.style}
    id={'toast'}
    onDismiss={closeToast}
  >
    {toast.title && <h4>{toast.title}</h4>}
    {toast.message && <p>{toast.message}</p>}
  </Alert>
);

Toast.propTypes = {
  toast: types.Toast,
  closeToast: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  toast: selectors.toast(state),
});
const mapDispatchToProps = dispatch => bindActionCreators(
  pick(actions, [
    'closeToast',
  ]),
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(Toast);

